import { storeManager } from '../../../core/store/store-manager.ts';
import { prescript } from '../../../core/providers/prescript.ts';

function getSafeViewportHeight(): number {
  return window.visualViewport ? window.visualViewport.height : window.innerHeight;
}

function adjustDrawerHeight() {
  const drawer = document.getElementById('fashion-hint-drawer') as HTMLDivElement | null;
  if (!drawer) return;
  drawer.style.height = `${getSafeViewportHeight()}px`;
}

export function toggleDrawerEventHandler() {
  const drawer = document.getElementById('fashion-hint-drawer');

  if (!drawer) {
    const newDrawer = document.createElement('div');
    newDrawer.id = 'fashion-hint-drawer';
    newDrawer.style.position = 'fixed';
    newDrawer.style.top = '0';
    newDrawer.style.right = '0';
    newDrawer.style.left = '0';
    newDrawer.style.width = '100%';
    newDrawer.style.zIndex = '9999';
    document.body.appendChild(newDrawer);

    const iframeDrawer = document.createElement('iframe');
    iframeDrawer.setAttribute('name', 'drawer');

    const sessionId = storeManager.getCookie('SIZEBAY_SESSION_ID_V4');
    const personaHash = storeManager.getCookie('SIZEBAY_PERSONA_HASH');

    const params = new URLSearchParams({
      baseUrl: prescript.baseVrfUrl,
      defaultUnit: prescript.defaultUnit,
      sessionId,
      personaHash,
      tenantId: String(prescript.tenantId),
      collectionName: prescript.collectionName,
      permalink: prescript.permalink,
      sizeSystem: prescript.sizeSystem,
      lang: prescript.lang,
      currency: prescript.currency,
      page: '1',
      perPage: String(prescript.perPage),
    });

    iframeDrawer.src = `${prescript.baseFashionHintUrl}szb-drawer?${params.toString()}`;
    iframeDrawer.id = 'fashion-hint-iframe-drawer';
    iframeDrawer.style.width = '100%';
    iframeDrawer.style.height = '100%';
    iframeDrawer.style.border = 'none';

    newDrawer.appendChild(iframeDrawer);
    adjustDrawerHeight();
    return;
  }

  drawer.remove();
}

export function closeFullscreenModalEventHandler() {
  const drawer = document.getElementById('fashion-hint-drawer');
  if (drawer) drawer.remove();
}
